<template>
  <IbxScopedCss>
    <q-form>
      <q-card
        class="flex flex-col relative w-[432px] overflow-hidden"
        data-testid="edit-user--save-changes-dialog"
      >
        <div class="row items-center mt-[40px] mb-[16px] p-0 justify-center">
          <h3 class="gordita-500-11-m text-[20px] text-Text/text_high">{{ dialogTitle }}</h3>
        </div>
        <div class="row items-center dialog-body-wrapper justify-center mb-[24px]">
          <div class="text-Text/text_medium font-[400] text-[14px]">{{ body }}</div>
        </div>
        <div class="w-full row justify-center mb-[24px] p-[16px] gap-[16px]">
          <incredi-button
            data-testid="edit-user--save-changes-dialog-cancel-button"
            v-close-popup
            design="ghost-green"
            rounded="true"
            size="small"
            @click.prevent.stop="cancelClicked"
          >
            <div>{{ cancelLabel }}</div>
          </incredi-button>

          <incredi-button
            data-testid="edit-user--save-changes-dialog-ok-button"
            v-close-popup
            design="primary-green"
            rounded="true"
            size="small"
            @click.prevent.stop="okClicked"
          >
            <div class="px-[8px]">{{ okLabel }}</div>
          </incredi-button>
        </div>
        <div class="bottom-gradient">
          <div class="bottom-gradient1"></div>
          <div class="bottom-gradient2"></div>
        </div>
      </q-card>
    </q-form>
  </IbxScopedCss>
</template>

<script>
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { IncrediButton } from 'incredi-ui';

export default {
  name: 'SaveChangesDialog',
  components: { IncrediButton, IbxScopedCss },
  model: {
    events: ['cancel', 'ok'],
  },
  props: {
    dialogTitle: { type: String, required: true },
    body: { type: String, required: true },
    okLabel: { type: String, default: 'Ok' },
    cancelLabel: { type: String, default: 'Cancel' },
  },
  methods: {
    okClicked() {
      this.$emit('ok');
    },
    cancelClicked() {
      this.$emit('cancel');
    },
  },
};
</script>

<style lang="scss" scoped>
.bottom-gradient {
  position: absolute;
  bottom: 0;
  left: 0%;
  height: 24px;
  width: 100%;
}
.bottom-gradient1 {
  position: absolute;
  height: 24px;
  left: 0%;
  right: -0.23%;
  bottom: 0px;

  background: linear-gradient(90deg, rgba(0, 240, 185, 0.859375) -3.46%, #00f0b9 10.68%, rgba(0, 240, 185, 0) 50.87%);
  opacity: 0.5;
}

.bottom-gradient2 {
  position: absolute;
  height: 17px;
  left: 0%;
  right: 0%;
  bottom: -1px;

  background: linear-gradient(70.93deg, #0bece2 26.54%, #03e8b4 67.13%);
  opacity: 0.8;
}
</style>
